<h2>Playground</h2>

<h2>Document uploader</h2>


<app-document-upload uploadMode="single" uploadStyle="icon"></app-document-upload>
<app-document-upload uploadMode="multiple"></app-document-upload>
<!-- <h2>Data Table</h2>
<br />
<div>
  <app-phoenix-table 
    header="Phoenix Data Table"
    [config]="tableConfig" 
    [data]="tableData"
    [controls]="true"
  />
</div> -->

<h2>PDF Editor</h2>
<br>
<!-- <form [formGroup]="pdfForm">
  <div formGroupName="memberName">
    <label for="memberName">Member name:</label>
    <input type="text" id="memberName" formControlName="userValue">
  </div>
  <div formGroupName="memberPhone">
    <label for="memberPhone">Member phone:</label>
    <input type="text" id="memberPhone" formControlName="userValue">
  </div>
  <div formGroupName="memberEmail">
    <label for="memberEmail">Member email:</label>
    <input type="text" id="memberEmail" formControlName="userValue">
  </div>
  <div formGroupName="primary">
    <label for="primary">primary:</label>
    <input type="checkbox" id="primary" formControlName="userValue">
  </div>
  <div formGroupName="homeBound">
    <label for="homeBound">homeBound:</label>
    <input type="checkbox" id="homeBound" formControlName="userValue">
  </div>
</form> -->
<app-pdf-editor
  pdfSrc="/assets/documents/MNF-NutritionalProducts_web.pdf"
  [form]="pdfForm"
  [logChanges]="true"
  [showDownloadButtons]="true"
  height="100vh"
/>

